import { Paper, Typography, Divider, makeStyles } from '@material-ui/core';
import ReactMarkdown from 'react-markdown';
import { ConversationMessage as MessageType } from './types';

const useStyles = makeStyles(theme => ({
  userMessage: {
    padding: theme.spacing(1, 2),
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.getContrastText(theme.palette.primary.light),
    borderRadius: theme.shape.borderRadius,
    alignSelf: 'flex-end',
    maxWidth: '80%',
  },
  assistantMessage: {
    padding: theme.spacing(1, 2),
    backgroundColor: theme.palette.background.default,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    alignSelf: 'flex-start',
    maxWidth: '80%',
  },
  messageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(0.5),
  },
  timestamp: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
  },
}));

interface MessageProps {
  message: MessageType;
}

export const ConversationMessageComponent: React.FC<MessageProps> = ({
  message
}) => {
  const classes = useStyles();

  return (
    <Paper
      className={message.type === 'user' ? classes.userMessage : classes.assistantMessage}
      elevation={message.type === 'user' ? 1 : 0}
    >
      <div className={classes.messageHeader}>
        <Typography variant="subtitle2">
          {message.type === 'user' ? 'You' : 'AI Agent'}
        </Typography>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="caption" className={classes.timestamp}>
            {message.timestamp.toLocaleTimeString()}
          </Typography>
        </div>
      </div>
      <Divider style={{ margin: '4px 0' }} />
      {message.type === 'assistant' ? (
        <ReactMarkdown>{message.content}</ReactMarkdown>
      ) : (
        <Typography>{message.content}</Typography>
      )}
    </Paper>
  );
};
